import React from "react";
import { getImageUrl } from "../../../services/asset";
import styles from "./Logo.scss";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

const Logo = () => (
  <Link
    to={{ pathname: "/", state: { scroll: true } }}
    onClick={() =>
      ReactGA.event({
        category: "Povratak na naslovnicu",
        action: "Click",
        label: "Logo footer"
      })
    }
  >
    <img
      alt={"Logo"}
      src={getImageUrl("new-logo.svg")}
      className={styles.logo}
    />
  </Link>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Footer/Logo/Logo.tsx